import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/services/regulatory-affairs/authorized-representative-ec-rep")({
  head: () => buildRouteHead("/en/services/regulatory-affairs/authorized-representative-ec-rep", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/services/regulatory-affairs/authorized-representative-eu-rep", replace: true });
  },
});
